import React from 'react';
import Logo from 'js/reusable/Logo/container';
import {__} from 'js/tool/page/current';

type IProps = {
	children: React.ReactNode;
}

function LoginBox({children}: IProps) {
	return (
		<div className="login-screen">
			<div className="login-box">
				<div className="tw-py-3">
					<Logo className="tw-h-14 tw-mx-auto" />
				</div>

				{children}
			</div>
			<div className="tw-flex tw-text-xs tw-mt-3 tw-gap-3">
				<a
					href="https://www.alephholding.com/privacy-policy"
					target="_blank"
				>
					{__('fb:data protection policy')}
				</a>
			</div>
		</div>
	);
}

export default LoginBox;
